import { useQuery } from 'react-query';
import axios from 'axios';
import jsonpAdapter from '../logic/axios-jsonp';
import { getSolrUrls } from './utils';
import { GetSessionID } from '../main/MandalaSession';
import { getProject } from '../views/common/utils';

// Declare all needed constants.
const solr_urls = getSolrUrls();
const ALL = [
    'audio-video',
    'images',
    'texts',
    'visuals',
    'sources',
    'subjects',
    'places',
    'terms',
];
const facetJson = JSON.stringify({
    asset_counts: {
        limit: 20,
        type: 'terms',
        field: 'asset_type',
        domain: { excludeTags: 'ast' },
    },
});

/**
 * useKmapRelatedTerms is a custom React Hook implementing useQuery from react-query to query
 * SOLR indices for information concerning kmaps related assets and their counts.
 * It is a copy of useKmapRelatedTerms but it fetchs from kmterms the related subject records that are
 * children of the Kmap solr record but are not indexed in kmassets
 *
 * @param kmapid
 * @param type
 * @param start
 * @param rows
 * @param definitionID
 * @param filtered
 * @returns {any}
 */
export function useKmapRelatedTerms(
    kmapid,
    type = 'all',
    start = 0,
    rows = 100,
    definitionID = 'noDefID',
    filtered = true
) {
    const asset_types = type === 'all' ? ALL : [type];

    return useQuery(
        [
            'kmapRelatedTerms',
            kmapid,
            asset_types.join('-'),
            start,
            rows,
            definitionID,
            filtered,
        ],
        () =>
            getKmapRelatedTermsData(
                kmapid,
                asset_types,
                start,
                rows,
                definitionID,
                filtered
            ),
        { keepPreviousData: true }
    );
}

const getKmapRelatedTermsData = async (
    kmapid,
    asset_types,
    start,
    rows,
    definitionID,
    filtered
) => {
    const defID =
        definitionID === 'noDefID' || String(definitionID) === 'any'
            ? kmapid
            : definitionID;

    const kid = kmapid.includes('-') ? kmapid.split('-')[1] : kmapid;
    let params = {
        fl: 'related_subjects_id_s',
        wt: 'json',
        start: start,
        rows: rows,
        // eslint-disable-next-line
        //q: `(uid:${kmapid}^100+kmapid:${defID})`,
        q: `uid:${defID}_*`,
        kmapid: kmapid,
        fq: [
            // '{!tag=ast}asset_type:(' + asset_types.join(' ') + ')',
            `block_child_type:related_subjects`,
        ],
    };

    const sid = GetSessionID();
    if (sid) {
        params.sid = sid;
    }

    // Filter by project?
    if (filtered) {
        const project = getProject();
        if (project) {
            let q = params.q;
            if (!q.includes('projects_ss:')) {
                q += ` AND projects_ss:${project}`;
            }
            params.q = q;
        }
    }

    const request = {
        adapter: jsonpAdapter,
        callbackParamName: 'json.wrf',
        url: solr_urls.terms,
        params: params,
    };

    const { data } = await axios.request(request);
    return data?.response?.docs;
};
